import React, { useEffect, useState } from "react";

import api from "../services/api";
import usePrevisionsStore from "../store/previsionsStore";
import { FaEdit, FaTrash } from "react-icons/fa";
import ConfirmationModal from "./ConfirmationModal";
import DeleteButton from "./DeleteButton";
import { useNavigate } from "react-router-dom";

const PrevisoesList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { previsions, getAllPrevisions, removePrevision } =
    usePrevisionsStore();
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPrevisoes = async () => {
      try {
        await getAllPrevisions();
      } catch (err) {
        setError("Erro ao carregar previsões. Tente novamente mais tarde.");
      } finally {
        setLoading(false);
      }
    };

    fetchPrevisoes();
  }, []);

  const handleDeletePrevision = async (id) => {
    try {
      const response = await api.delete(`/previsions/${id}`);
      console.log("response: ", response.data);
      removePrevision(id);
    } catch (error) {
      console.error("Erro ao excluir previsão: ", error);
      setErrorMessage(
        error.status === 400
          ? error.response.data.message
          : "Não foi possível excluir previsão"
      );

      return error.status === 400
        ? error.response.data.message
        : "Não foi possível excluir previsão";
    }
  };

  const handleEdit = (id) => {
    navigate(`/previsions/edit/${id}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-gray-500 text-lg">Carregando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-red-500 text-lg">{error}</p>
      </div>
    );
  }

  const originDictionary = {
    ORDERLOAD: "Carga",
    FRETEMARITIMO: "Frete Marítimo",
    CONTAINER: "Contêiner",
  };

  return (
    <div className="max-w-5xl mx-auto p-6 bg-gray-50 rounded-lg shadow-md mt-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Lista de Previsões
      </h2>
      <table className="w-full table-auto border-collapse bg-white rounded-lg shadow-lg">
        <thead>
          <tr className="bg-gray-200">
            <th className="px-4 py-2 border text-left text-sm font-medium text-gray-700">
              Nome
            </th>
            <th className="px-4 py-2 border text-left text-sm font-medium text-gray-700">
              Taxa
            </th>
            <th className="px-4 py-2 border text-left text-sm font-medium text-gray-700">
              Tipo
            </th>
            <th className="px-4 py-2 border text-left text-sm font-medium text-gray-700">
              Origem
            </th>
            <th className="px-4 py-2 border text-left text-sm font-medium text-gray-700">
              Valor
            </th>
            <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {previsions.map((prevision, index) => {
            const taxas = [
              {
                label: "AFRMM",
                value: prevision.afrmm_tax,
                type: prevision.afrmm_tax_type,
                from: prevision.afrmm_tax_from,
              },
              {
                label: "COLLECT DE FRENTE",
                value: prevision.freight_collect_tax,
                type: prevision.freight_collect_tax_type,
                from: prevision.freight_collect_tax_from,
              },
              {
                label: "OUTRAS DESPESAS DE FRETE",
                value: prevision.other_shipping_costs_tax,
                type: prevision.other_shipping_costs_tax_type,
                from: prevision.other_shipping_costs_tax_from,
              },
              {
                label: "ARMAZENAGEM",
                value: prevision.storage_tax,
                type: prevision.storage_tax_type,
                from: prevision.storage_tax_from,
              },
              {
                label: "DESEMBARAÇO ADUANEIRO",
                value: prevision.customs_clearance,
                type: prevision.customs_clearance_type,
                from: prevision.customs_clearance_from,
              },
              {
                label: "OUTRAS DESPESAS",
                value: prevision.other_expenses_tax,
                type: prevision.other_expenses_type,
                from: prevision.other_expenses_from,
              },
            ];

            return (
              <React.Fragment key={index}>
                {taxas.map((taxa, taxaIndex) => (
                  <tr key={`${index}-${taxaIndex}`}>
                    {taxaIndex === 0 && (
                      <td
                        className="px-4 py-2 border text-sm text-gray-700 bg-gray-100 capitalize"
                        rowSpan={taxas.length}
                      >
                        {prevision.name_previsions}
                      </td>
                    )}
                    <td className="px-4 py-2 border text-sm text-gray-700">
                      {taxa.label}
                    </td>
                    <td className="px-4 py-2 border text-sm text-gray-700">
                      {taxa.type === "PERCENTAGE"
                        ? "Porcentagem %"
                        : "Valor fixo"}
                    </td>
                    <td className="px-4 py-2 border text-sm text-gray-700">
                      {originDictionary[taxa.from] || "N/A"}
                    </td>
                    <td className="px-4 py-2 border text-sm text-gray-700">
                      {taxa.type === "FIXED" && "R$"}
                      {taxa.value?.toFixed(2) || "N/A"}
                      {taxa.type === "PERCENTAGE" && "%"}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700 flex items-center justify-center border-0">
                      {taxaIndex === 2 && (
                        <DeleteButton
                          onConfirm={() => handleDeletePrevision(prevision.id)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                        />
                      )}
                      {taxaIndex === 3 && (
                        <button
                          type="button"
                          className="p-2 text-blue-600 hover:text-blue-800"
                          onClick={() => handleEdit(prevision.id)}
                        >
                          <FaEdit />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
                {/* Adicionando espaçamento após cada previsão */}
                {index < previsions.length - 1 && (
                  <tr>
                    <td colSpan={6} className="h-6 bg-gray-50"></td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PrevisoesList;
